<section class="h5 d-flex flex-column flex-md-column flex-lg-row flex-xl-row gap-2">
    <strong class="mb-2">Step 1:</strong> 
    <span class="fw-normal">Discover if we can bring Philly’s best local finds to you</span>
</section>
<p class="text-muted mb-4 mt-2">Pop in your info below. If you’re in our delivery zone, we’ll be on your block soon with a
    box full of local flavor. If not, don’t worry, we’ll keep you posted as our community grows.</p>
@if (svc.isStepCompleted('delivery')) {
<div class="mt-2 mb-3 animated fadeIn">
    <button type="button" class="btn btn-sm btn-outline-primary" (click)="svc.openEditDeliveryAddressModal()">Edit
        delivery address</button>
</div>
}

<form [formGroup]="svc.addressForm" novalidate>
    <div class="row g-3 animated fadeInUp">
        <div class="col-12 col-md-6 col-xl-6">
            <label class="form-label small fw-medium">EMAIL* <i class="fas fa-info-circle text-primary"></i></label>
            <input type="email" class="form-control" formControlName="email" placeholder="email@gmail.com" #emailControl
                (blur)="onEmailBlur(emailControl)" [class.is-invalid]="invalid('email')"
                [class.is-valid]="valid('email')" [readonly]="svc.isStepCompleted('delivery')">
            <div class="invalid-feedback" *ngIf="invalid('email')">Valid email required</div>
        </div>
    </div>

    <div class="row g-3 mt-3 animated fadeInUp">
        <div class="col-12 col-md-6 col-xl-6">
            <label class="form-label small fw-medium">HOME ADDRESS*</label>
            @if (!svc.isStepCompleted('delivery')) {
            <app-autocomplete-input [autocompleteOff]="true" (validSelectedAddress)="onValidSelectedAddress($event)" [label]="'Address Line 1'"
                [inShowProspectWindow]="true" [inIsLabelRequired]="false"
                [inShowDefaultMessages]="false" [storeAnonymousUserAddress]="true"></app-autocomplete-input>
            } @else {
            <input type="text" class="form-control" [value]="deliveryAddress()?.street" readonly>
            }
        </div>
        <div class="col-12 col-md-6 col-xl-6">
            <label class="form-label small fw-medium">HOME ADDRESS</label>
            <input type="text" class="form-control" formControlName="address2" placeholder="Address line 2"
                [readonly]="svc.isStepCompleted('delivery')">
        </div>
    </div>

    <div class="row g-3 mt-3 animated fadeInUp">
        <div class="col-12 col-md-6">
            <label class="form-label small fw-medium">CITY*</label>
            <input type="text" class="form-control" formControlName="city" placeholder="City" autocomplete="off"
                [readOnly]="deliveryAddress()?.city || svc.isStepCompleted('delivery')"
                [class.is-invalid]="invalid('city')" [class.is-valid]="valid('city')">
            <div class="invalid-feedback" *ngIf="invalid('city')">Required</div>
        </div>
        <div class="col-12 col-md-3">
            <label class="form-label small fw-medium">STATE*</label>
            @if (!deliveryAddress()?.stateCode && !svc.isStepCompleted('delivery')) {
            <select class="form-select" formControlName="state" [class.is-invalid]="invalid('state')"
                [class.is-valid]="valid('state')">
                <option value="" disabled>State</option>
                <option *ngFor="let st of states()" [value]="st.id">{{ st.name }}</option>
            </select>
            } @else {
            <input type="text" class="form-control" formControlName="state" placeholder="State" readonly
                [class.is-invalid]="invalid('state')" [class.is-valid]="valid('state')">
            }
            <div class="invalid-feedback" *ngIf="invalid('state')">Required</div>
        </div>
        <div class="col-12 col-md-3">
            <label class="form-label small fw-medium">ZIP CODE*</label>
            <input type="text" class="form-control" formControlName="zip" placeholder="Zip Code" inputmode="numeric" autocomplete="off"
                [readOnly]="deliveryAddress()?.zipCode || svc.isStepCompleted('delivery')"
                [class.is-invalid]="invalid('zip')" [class.is-valid]="valid('zip')" appOnlyNumber maxlength="5">
            <div class="invalid-feedback" *ngIf="invalid('zip')">5 digits</div>
        </div>
    </div>

    @if (deliveryCoverageMessage()) {
    <div class="alert alert-success mt-5 mb-0 small text-start delivery-msg" role="status">
        You're in! Fresh, local food is officially within reach. We can deliver fresh, local food right to your door,
        and with your free account, you'll unlock access to the best food Philly's farms and makers have to offer.
    </div>
    }

    <!-- Botón para continuar -->
    <div class="d-flex justify-content-center mt-4">
        <button type="button" 
                class="btn btn-primary px-4" 
                [disabled]="!svc.canProceed('delivery')"
                (click)="onNext()">
            Next <span class="ms-1">→</span>
        </button>
    </div>
</form>